import { render, staticRenderFns } from "./Conduct.vue?vue&type=template&id=36e8f51a&scoped=true"
var script = {}
import style0 from "./Conduct.vue?vue&type=style&index=0&id=36e8f51a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8f51a",
  null
  
)

export default component.exports